var _path, _path2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M16.6 5.2h-2.9C10.6 5.2 8 7.7 8 10.9V32c0 3.1 2.5 5.7 5.7 5.7h15.2c3.1 0 5.7-2.5 5.7-5.7v-9.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M14.2 24.6h13.7M14.2 30.4h13.7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 15,
    cy: 14,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 21.3,
    cy: 5.2,
    r: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 25.6,
    cy: 5.1,
    r: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 29.8,
    cy: 5.1,
    r: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 34.2,
    cy: 5.1,
    r: 0.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 25.7,
    cy: 9.4,
    r: 0.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 30,
    cy: 9.4,
    r: 0.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 34.3,
    cy: 9.4,
    r: 0.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 30,
    cy: 13.7,
    r: 0.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 34.4,
    cy: 13.7,
    r: 0.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 34.5,
    cy: 18,
    r: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebInvoice);
export default __webpack_public_path__ + "static/media/webInvoice.2600414875fb8392c8bcf78c8197d501.svg";
export { ForwardRef as ReactComponent };